/*
 * Filename: picklist-value-source.controller.ts
 * Description: Handling Picklist value source rule
 */

import { CQMasterDataStore } from '../../../store/cq-master-data.store';

export class CQPicklistValueSourceController {
    public setPicklistValueSource = (templateName: string, categoryName: string) => {
        const selectedField: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
        CQMasterDataStore.PicklistValueSource.addPickListValueSource(selectedField.fullName, { [selectedField.fullName]: categoryName });
        CQMasterDataStore.OutputConfig.setPicklistValueSource(templateName, CQMasterDataStore.PicklistValueSource.FieldPickListData);
        const ruleElement = CQMasterDataStore.RuleElements.FieldRuleElement;
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName,'ruleElements',ruleElement);
    }
}

